import React, { useState } from 'react';
import Seo from './Seo';
import './ContactPage.css';

function ContactPage() {
  const [formData, setFormData] = useState({ name: '', email: '', message: '' });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert('Message sent! Thank you for contacting Tudu.');
    setFormData({ name: '', email: '', message: '' });
  };

  return (
    <div className="contact-wrapper">
      <Seo
        path="/contact"
        title="Contact Tudu — Get in Touch"
        description="Questions about Tudu? Reach out to our team for support, partnerships, or feedback on the smart task planner."
      />
      <div className="contact-container">
        <div className="contact-header">
          <h1>Get in <span className="brand-highlight">Touch</span></h1>
          <p className="contact-subtitle">
            Have questions or feedback? We'd love to hear from you.
          </p>
        </div>

        <div className="contact-card">
          <form className="contact-form" onSubmit={handleSubmit}>
            <div className="form-group">
              <label>Name</label>
              <input
                type="text"
                name="name"
                placeholder="Your Name"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label>Email</label>
              <input
                type="email"
                name="email"
                placeholder="your@email.com"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label>Message</label>
              <textarea
                name="message"
                rows="5"
                placeholder="How can we help?"
                value={formData.message}
                onChange={handleChange}
                required
              />
            </div>

            <button type="submit" className="submit-btn">Send Message</button>
          </form>
        </div>

        <div className="support-info">
          <p>Or email us directly at <a href="mailto:support@tudu.ai">support@tudu.ai</a></p>
        </div>
      </div>
    </div>
  );
}

export default ContactPage;
